export default {
  /**
   * Lỗi validate
   */
  Validate: 'VALIDATE',

  // Mã lỗi dữ liệu danh mục trùng mã
  Validate_Dictionary_Duplicate: 'VALIDATE_DICTIONARY_DUPLICATE',
};
